import React from "react";
import "./card.scss";
function card({ heading, imgurl, para }) {
  return (
    <div className="Cart">
      <div className="imgSection">
        <img src={imgurl} alt="" />
      </div>
      <div className="heading">
        <h4 style={{color:"blue"}}>{heading}</h4>
        <p>{para}</p>
      </div>
    </div>
  );
}

export default card;
